<template>

  <body>
    <!-- **************** MAIN CONTENT START **************** -->
    <main style="direction: rtl; text-align: right;">
      <!-- Main content START -->
      <div class="main-background pt-2 pb-0 position-relative">
        <!-- Container START -->
        <div class="container">
          <div class="row justify-content-center">
            <img class="light-mode-item navbar-brand-item" style="height: 180px;width: 210px;"
              src="../../assets/logo-dark.png" alt="logo">
            <div class="col-12 text-center">
              <span class="display-5 mainText">حساب جديد</span>
            </div>
            <div class="col-sm-10 col-md-8 col-lg-6 position-relative z-index-1">
              <div class="card card-body p-4 p-sm-5 mt-sm-n5 mb-n5">
                <form @submit.prevent="handleSignup">
                  <!-- Email -->
                  <div class="mb-3 input-group-lg">
                    <span class="d-block form-text-style">الايميل *</span>
                    <input type="email" v-model="email" class="form-control" placeholder="أدخل الايميل" required>
                  </div>
                  <!-- Username -->
                  <div class="mb-3 input-group-lg">
                    <span class="d-block form-text-style">الاسم *</span>
                    <input type="text" v-model="username" class="form-control" placeholder="اسمك" required>
                  </div>
                  <!-- Password -->
                  <div class="mb-3 input-group-lg">
                    <span class="d-block form-text-style">كلمة السر *</span>
                    <input type="password" v-model="password" class="form-control" placeholder="أدخل كلمة السر"
                      required>
                  </div>
                  <!-- Phone -->
                  <div class="mb-3 input-group-lg">
                    <span class="d-block form-text-style">رقم الهاتف *</span>
                    <input type="tel" v-model="phone" class="form-control" placeholder="أدخل رقم الهاتف" required>
                  </div>
                  <!-- Button -->
                  <div class="d-grid">
                    <button type="submit" class="btn btn-lg signup-btn">انشاء حساب</button>
                  </div>
                </form>
                <!-- Copyright -->
                <p class="mb-0 mt-3 text-center">لديك حساب بالفعل؟ <span class="form-text-style-account">
                    <router-link to="/login" class="btn-signup">
                      تسجيل الدخول
                    </router-link>
                  </span></p>
                <!-- Form END -->
                <div class="divider mb-0 mt-3 text-center">
                  <span>أو</span>
                </div>
                <div class="d-grid">
                  <router-link class="btn-signup">
                    <GoogleLogin :clientId="YOUR_GOOGLE_CLIENT_ID" class="btn-signup" @success="onGoogleSignInSuccess"
                      @error="onGoogleSignInError">
                      تسجيل بواسطة جوجل
                    </GoogleLogin>
                  </router-link>
                </div>
                <div v-if="errorMessage" class="text-danger mt-3">{{ errorMessage }}</div>
                <div v-if="successMessage" class="text-success mt-3">{{ successMessage }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container END -->
      </div>
    </main>
    <Footer />
  </body>
</template>

<script>
import axios from "axios";
import Footer from "../components/footer.vue";
import { GoogleLogin } from 'vue3-google-login';

export default {
  name: "SignupPage",
  components: {
    Footer,
    GoogleLogin,
  },
  data() {
    return {
      username: "",
      email: "",
      password: "",
      phone: "",
      errorMessage: "",
      successMessage: "",
      YOUR_GOOGLE_CLIENT_ID: "http://572471366403-vhse1b2619rjj16rrgl9k64ths8d1s1m.apps.googleusercontent.com", // استبدل هذا بمعرف العميل الخاص بك
    };
  },
  methods: {
    async handleSignup() {
      this.errorMessage = "";
      this.successMessage = "";

      try {
        // التحقق من الحقول المطلوبة
        if (!this.username || !this.email || !this.password || !this.phone) {
          this.errorMessage = "يرجى ملء جميع الحقول المطلوبة.";
          return;
        }

        // إنشاء البيانات المرسلة
        const formData = new FormData();
        formData.append("username", this.username);
        formData.append("email", this.email);
        formData.append("password", this.password);
        formData.append("phone", this.phone);

        // إرسال الطلب
        const response = await axios.post(
          "https://zadcodeonline.com/ahmad/etqan/backEnd/auth/signup.php",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        // معالجة الاستجابة
        if (response.data.status === "success") {
          this.successMessage = "تم إنشاء الحساب بنجاح!";
          setTimeout(() => {
            this.$router.push("/login"); // توجيه المستخدم إلى صفحة تسجيل الدخول
          }, 2000);
        } else {
          this.errorMessage = "خطأ في تسجيل الحساب.";
        }
      } catch (error) {
        this.errorMessage = "حدث خطأ أثناء محاولة تسجيل الحساب.";
      }
    },
    onGoogleSignInSuccess(response) {
      const idToken = response.credential; // الـ ID token من Google
      const email = response.profileObj.email; // البريد الإلكتروني من Google

      axios.post(
        "https://zadcodeonline.com/ahmad/etqan/backEnd/auth/signinwithgoogle.php",
        {
          idgoogle: idToken,
          email: email,
        }
      ).then((response) => {
        if (response.data.status === "success") {
          localStorage.setItem("isAuthenticated", "true");
          localStorage.setItem("userId", response.data.data.users_id);
          this.$router.push("/home");
        } else {
          this.errorMessage = "خطأ في تسجيل الدخول باستخدام Google.";
        }
      }).catch(() => {
        this.errorMessage = "حدث خطأ أثناء محاولة تسجيل الدخول باستخدام Google.";
      });
    },
    onGoogleSignInError(error) {
      this.errorMessage = "حدث خطأ أثناء محاولة تسجيل الدخول باستخدام Google.";
      console.error(error);
    },
  },
};
</script>

<style scoped>
footer {
  bottom: 0;
  left: 0;
  width: 100%;
  color: #fff;
  background-color: #296080;
  padding: 20px;
  text-align: center;
  margin-top: 100px !important;
}

/* تحسين الخلفية */
.main-background {
  background: linear-gradient(to bottom, #f7f9fa, #d9e8ed);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* تحسين النصوص */
.mainText {
  color: #296080;
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
}

/* تأثيرات الأزرار */
.signup-btn:hover {
  background-color: #3a739b;
  transition: all 0.3s ease;
  transform: scale(1.02);
}

.signup-btn-google:hover {
  background-color: #f0f0f0;
  color: #000;
  transition: all 0.3s ease;
  transform: scale(1.02);
}

/* الحقول */
.form-control {
  border-radius: 12px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #296080;
  box-shadow: 0px 0px 10px rgba(41, 96, 128, 0.5);
}

/* أيقونات */
.input-group-lg {
  position: relative;
}

.input-group-lg input {
  padding-left: 40px;
}

.input-group-lg::before {
  content: attr(data-icon);
  font-family: FontAwesome;
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 1.2rem;
  color: #296080;
}

/* تحسين النصوص */
.form-text-style {
  font-weight: 700;
  margin-bottom: 5px !important;
}

.form-text-style-password:hover {
  color: #FF6F61;
  text-decoration: underline;
  cursor: pointer;
}

/* شريط التحميل */
.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #296080;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-right: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}




h3 {
  margin: 40px 0 0;
}

.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  position: relative;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background-color: #ccc;
  margin: 0 10px;
}

.divider span {
  margin-bottom: 30px;
  display: inline-block;
  font-weight: 700;
  padding: 0 10px;
  background: #fff;
  font-size: 1rem;
  color: #333;
}

.mainText {
  color: #296080;
  right: 15px;
  text-align: right;
}

.mb-n5 {
  margin-top: 15px !important;
}

.form-text-style {
  font-weight: 700;
  margin-bottom: 5px !important;
}

.form-text-style-password {
  color: #EF845D;
  margin-bottom: 15px !important;
  border-bottom: 1px solid #EF845D;
}

.btn-signup {
  color: #296080;
}


.form-text-style-account {
  color: #EF845D;
}

.main-background {
  background-color: #D9E8ED;
}

.form-control {
  border-radius: 12px;
}

.signup-btn {
  background-color: #296080;
  color: #fff;
  border-radius: 12px;
}

.signup-btn-google {
  color: #000000;
  border-radius: 12px;
  border: 1px solid #929292;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
